import React from "react";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { all_routes } from "../../router/all_routes";

const PrivacyPolicy = () => {
  return (
    <div className="main-wrapper">
      <div className="text-center mt-4">
        <ImageWithBasePath
          src="assets/images/logo.png"
          alt="iKidz"
           width={150}
          // height={200}
          className="img-fluid"
        />
      </div>

     <div className="card-body p-4">
  <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
    <h3 className="mb-0">Privacy Policy</h3>
    <Link to={all_routes.login} className="btn btn-outline-primary btn-sm">
      Back to Login
    </Link>
  </div>

  <p className="text-muted"><strong>Effective Date:</strong> April 2026</p>

  <p className="text-muted">
    iKidz ("we", "our", or "us") provides a school communication and monitoring
    platform for schools, parents, and authorized staff. This Privacy Policy
    explains how we collect, use, disclose, and safeguard information when you use
    the iKidz mobile applications (Android and iOS) and related services.
  </p>

  <h6 className="mt-4">1. Information We Collect</h6>
  <ul className="text-muted">
    <li>Account information (name, email address, phone number, user role)</li>
    <li>Student information provided by schools (attendance records, class details)</li>
    <li>Authentication data (login credentials, user ID)</li>
    <li>Device information (device model, OS version, IP address)</li>
    <li>Usage data (app interactions and feature usage)</li>
  </ul>

  <h6 className="mt-4">2. Live CCTV Streaming</h6>
  <p className="text-muted">
    The iKidz app may provide live CCTV streaming for authorized parents and school staff.
    Access to live video feeds is strictly restricted to authenticated users approved by
    the respective school. Video streams are not publicly accessible.
  </p>

  <h6 className="mt-4">3. How We Use Information</h6>
  <ul className="text-muted">
    <li>To provide attendance tracking and student information access</li>
    <li>To enable secure login and authentication</li>
    <li>To provide authorized access to live CCTV streams</li>
    <li>To improve app performance and user experience</li>
    <li>To send important notifications related to school activities</li>
  </ul>

  <h6 className="mt-4">4. Data Sharing and Disclosure</h6>
  <p className="text-muted">
    We do not sell personal information. We may share data with trusted third-party
    service providers (such as cloud hosting or analytics services) strictly for
    operating and improving the platform. We may disclose information if required by law.
  </p>

  <h6 className="mt-4">5. Data Security</h6>
  <p className="text-muted">
    We implement appropriate technical and organizational safeguards to protect
    personal information against unauthorized access, alteration, disclosure, or
    destruction. Access to student information and live streams is restricted
    to authorized users only.
  </p>

  <h6 className="mt-4">6. Data Retention</h6>
  <p className="text-muted">
    Personal data is retained only as long as necessary to provide services
    to schools and users or as required by applicable laws. Schools control
    the duration of student data storage within the system.
  </p>

  <h6 className="mt-4">7. Children's Privacy</h6>
  <p className="text-muted">
    iKidz is designed for use by schools and parents. Student data is provided
    and managed by authorized educational institutions. We do not knowingly
    collect personal information directly from children without school authorization.
  </p>

  <h6 className="mt-4">8. User Rights</h6>
  <p className="text-muted">
    Users may request access, correction, or deletion of their personal data
    by contacting their school administrator or by emailing us at the contact
    information below.
  </p>

  <h6 className="mt-4">9. Third-Party Services</h6>
  <p className="text-muted">
    The app may use trusted third-party services such as cloud hosting,
    analytics, or push notification providers to operate effectively.
    These providers process data only on our behalf and under strict
    confidentiality obligations.
  </p>

  <h6 className="mt-4">10. Changes to This Policy</h6>
  <p className="text-muted">
    We may update this Privacy Policy from time to time. Any changes will be
    posted on this page with an updated effective date.
  </p>

  <h6 className="mt-4">11. Contact Us</h6>
  <p className="text-muted">
    If you have any questions about this Privacy Policy, please contact us at:
    <br />
    Email: support@ikidzschools.com
  </p>
</div>
    </div>
  );
};

export default PrivacyPolicy;

